import { createRequestActionTypes } from '../../helpers'

export const FETCH_FAQS = createRequestActionTypes('FAQS', 'FETCH')
export const FETCH_FAQ_CATEGORIES = createRequestActionTypes(
  'FAQ_CATEGORIES',
  'FETCH'
)
